<template>
  <div
    class="left-panel document-details d-flex flex-column"
    data-testid="document-left-panel"
  >
    <document-view-tool-button
      id="open-toggle-left"
      tooltip-title="Toggle panel"
      :toggle-rotated="toggleRotated"
      icon="medium-layout-column-left-hide"
      @button-click="togglePanel()"
      data-dd-action-name="document-left-panel-toggle-panel-button"
    />

    <div class="scroll-container">
      <i-accordion :allow-multi-open="true">
        <!-- doc info -->
        <i-accordion-item
          title="Document"
          :no-background="true"
          :mount-open="true"
          size="large"
        >
          <div
            class="document-stats d-flex flex-column align-items-start justify-content-start accordion-content"
          >
            <!-- create date -->
            <data-block
              left-icon="small-calendar-date"
              label="Uploaded"
              :value="formatDateTime(document.created_at, 'lll')"
            ></data-block>

            <!-- pages count -->
            <data-block
              left-icon="small-book-open"
              label="Page Count"
              :value="totalPagesText"
            ></data-block>

            <!-- format -->
            <data-block
              v-if="document.file_type"
              left-icon="small-file"
              label="Format"
              help-link="3505136-capabilities-by-file-type"
              :value="documentFileTypeText(document.file_type)"
            >
            </data-block>

            <!-- type -->
            <data-block
              v-if="
                document.document_type &&
                document.document_type !== documentTypes.UNKNOWN
              "
              left-icon="small-bookmark"
              label="Type"
              help-link="5775977-classification"
              :value="documentTypeText(document.document_type)"
            >
            </data-block>

            <!-- subtypes -->
            <div v-if="document.subtypes.length > 0" class="d-flex flex-column">
              <data-block
                v-for="subtype in document.subtypes"
                :key="subtype"
                left-icon="small-bookmark-double"
                label="Subtype"
                :value="documentSubtypeText(subtype)"
              >
              </data-block>
            </div>

            <!-- authors -->
            <data-block
              v-for="authorObject in metadataAuthors"
              :key="authorObject.label"
              left-icon="small-shopping-store-2"
              label="Author"
            >
              <metadata-value :metadata-items="authorObject.value" />
            </data-block>

            <!-- quality score -->
            <data-block
              v-if="document.quality_score || document.quality_score === 0"
              left-icon="small_gauge_circle_high"
              label="Quality Score"
              help-link="5567690-quality-score"
              :value="document.quality_score"
            >
            </data-block></div
        ></i-accordion-item>
        <!-- key parsed info -->
        <i-accordion-item
          v-if="showParsedDetails"
          :no-background="true"
          :mount-open="true"
          title="Content"
          size="large"
        >
          <div
            class="document-stats d-flex flex-column align-items-start justify-content-start accordion-content"
          >
            <parsed-details-list :document="document" />
          </div>
        </i-accordion-item>
      </i-accordion>
    </div>
  </div>
</template>
<script>
import { iAccordion, iAccordionItem } from '@inscribe/signal';
import MetadataValue from '@/V2/documents/MetadataValue';
import * as documentTypes from '@/constants/documentTypes';
import { flattenMetadata } from '@/utils/metadata';
import ParsedDetailsList from '@/V2/documents/ParsedDetailsList';
import DataBlock from '@/V2/components/DataBlock';
import { getDocumentTypeText } from '@/utils/documentType';
import { getDocumentSubtypeText } from '@/utils/documentSubtype';
import { getFileTypeText } from '@/utils/fileType';
import { formatDateTime } from '@/utils/date';
import DocumentViewToolButton from '@/V2/documents/document-view/DocumentViewToolButton.vue';
export default {
  name: 'DocumentLeftPanel',
  components: {
    DataBlock,
    iAccordion,
    iAccordionItem,
    MetadataValue,
    ParsedDetailsList,
    DocumentViewToolButton,
  },
  props: {
    document: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      documentTypes,
      toggleRotated: false,
    };
  },
  computed: {
    totalPagesText() {
      return `${this.document.total_pages} ${
        this.document.total_pages > 1 ? 'Pages' : 'Page'
      }`;
    },
    metadataAuthors() {
      const metadata = flattenMetadata(
        this.document.metadata,
        (key, value) => key.toLowerCase() === 'author' && !!value,
        (key) => key.toLowerCase(),
      );

      return Object.entries(metadata).map(([label, value]) => ({
        label,
        value,
      }));
    },
    showParsedDetails() {
      return Object.keys(this.document.parsed_details).length > 0;
    },
  },
  methods: {
    togglePanel(side) {
      this.$emit('toggle-panel', 'left');
      this.toggleRotated = !this.toggleRotated;
    },
    documentTypeText: getDocumentTypeText,
    documentSubtypeText: getDocumentSubtypeText,
    documentFileTypeText: getFileTypeText,
    formatDateTime,
  },
};
</script>
<style lang="scss" scoped>
.left-panel {
  position: relative;
  background: $light-neutral-default;
  border-right: 1px solid $light-neutral-60;

  .document-view-tool-button {
    position: absolute;
    left: calc(100% + 16px);
    bottom: 16px;
    z-index: 100;
  }

  .scroll-container {
    overflow-x: hidden;
    overflow-y: auto;
  }

  .metadata-value {
    color: $light-neutral-120;
    font-size: 12px;
    font-weight: 600;
  }
}
</style>
